//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { AutoCompleteExtraProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { SalaryDeviationFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import { useCompanyService, useSalaryDeviationsService } from "serviceHooks";
//#endregion
import { DateHelper, QueryStateHelper } from "utils/helpers";

function useSalaryDeviationReportFilterDefinition() {
  const companyService = useCompanyService();
  const salaryDeviationsService = useSalaryDeviationsService();

  const apiToReportFilterFormatter = async (filter: WintSuperkollAPIModel.SalaryDeviationFilter) => {
    const reportFilter: SalaryDeviationFormTypes.Filter = {};

    if (filter.yearAndMonth !== undefined) {
      reportFilter.yearAndMonth = DateHelper.getDateFromYearMonth(filter.yearAndMonth);
    }

    let personName: Promise<string> | undefined;
    if (filter.personId !== undefined) {
      reportFilter.personId = filter.personId;
      personName = companyService.getEmployeeName(filter.personId);
    }

    if (filter.types !== undefined) {
      reportFilter.types = filter.types;
    }

    if (personName) {
      reportFilter.personName = await personName;
    }

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<SalaryDeviationFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        yearAndMonth: {
          label: TranslationKeys.Common.TimePeriod,
          type: FormEnums.FormFieldType.MONTH,
        },
        personName: {
          label: TranslationKeys.Common.Employee,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          extraProps: {
            referenceFieldName: FormFieldConstants.SalaryDeviation.Filter.PersonId,
            items: (searchStr: string) => companyService.SearchPersonsAutoComplete(searchStr, false),
          } as AutoCompleteExtraProps<SalaryDeviationFormTypes.Filter>,
          hidden: !salaryDeviationsService.hasAdminPermissions(),
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<SalaryDeviationFormTypes.Filter> = {
    yearAndMonth: QueryStateHelper.monthQueryEncoder(FormFieldConstants.SalaryDeviation.Filter.YearAndMonth),
    personId: QueryStateHelper.numberQueryEncoder(FormFieldConstants.SalaryDeviation.Filter.PersonId),
    personName: QueryStateHelper.stringQueryEncoder(FormFieldConstants.SalaryDeviation.Filter.PersonName),
  };

  return { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter };
}

export default useSalaryDeviationReportFilterDefinition;
